import React from 'react';
import {
  Block,
} from '@uncinc/react-drupal-core';

import {
  BLOCK_NEWSLETTER_FOOTER_BLOCK_ID,
} from '../../config/constants';

import './style.scss';

const NewsletterSignupFooter = (props) => {
  return (
    <div className="NewsletterSignupFooter">
      <Block id={BLOCK_NEWSLETTER_FOOTER_BLOCK_ID} />
    </div>
  );
};

export default NewsletterSignupFooter;
